import {
  GiveawayDetailed,
  GiveawayDetailedArchive,
} from '@/entities/giveaway/types';
import styles from './DetailedGiveawayPrizes.module.scss';
import GiveawayPrizesActive from './GiveawayPrizesActive';
import DetailedPrizesArchive from './DetailedPrizesArchive';

interface DetailedGiveawayPrizesProps {
  giveaway: GiveawayDetailed | GiveawayDetailedArchive;
}

const DetailedGiveawayPrizes = ({ giveaway }: DetailedGiveawayPrizesProps) => {
  return (
    <div className={styles.giveawayPrizeDetails}>
      <div className={styles.chanceText}>
        <div className={styles.chanceTopInfo}>Призовой фонд</div>
        <div className={styles.chanceBottomInfo}>1 купон = 1 шанс выиграть</div>
      </div>

      {giveaway.status === 'active' ? (
        <GiveawayPrizesActive giveaway={giveaway as GiveawayDetailed} />
      ) : (
        <DetailedPrizesArchive giveaway={giveaway as GiveawayDetailedArchive} />
      )}
    </div>
  );
};

export default DetailedGiveawayPrizes;
